module.exports = __webpack_public_path__ + "8857d39a8eb99fe3c11f83f6e7e2430a.fbx";